var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4512 12.4141H4.53939C2.58572 12.4141 1.00195 13.9978 1.00195 15.9515V44.2513C1.00195 46.205 2.58572 47.7888 4.53939 47.7888H43.4512C45.4049 47.7888 46.9887 46.205 46.9887 44.2513V15.9515C46.9887 13.9978 45.4049 12.4141 43.4512 12.4141Z",
    stroke: "#1D1DE3",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9212 1.80176H31.071C32.0092 1.80176 32.9089 2.17445 33.5723 2.83786C34.2357 3.50126 34.6084 4.40103 34.6084 5.33923V12.4142H13.3838V5.33923C13.3838 4.40103 13.7565 3.50126 14.4199 2.83786C15.0833 2.17445 15.983 1.80176 16.9212 1.80176Z",
    stroke: "#1D1DE3",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6143 24.7959H36.3763",
    stroke: "#1D1DE3",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6143 35.4082H36.3763",
    stroke: "#1D1DE3",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage);
export default __webpack_public_path__ + "static/media/luggage.eecd084891a54f6272a672e457cff445.svg";
export { ForwardRef as ReactComponent };